import { z } from "zod";

export const AssetVisibilitySchema = z.enum(["agent", "private"]);
export type AssetVisibility = z.infer<typeof AssetVisibilitySchema>;
